'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INITIALIZE = exports.REMOVE = exports.UPDATE = exports.INSERT = exports.LOAD = exports.ERROR = exports.RESPONSE = exports.CHANGE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.BaseMessage = BaseMessage;
exports.ChangeMessage = ChangeMessage;
exports.ResponseMessage = ResponseMessage;
exports.RequestMessage = RequestMessage;
exports.ErrorMessage = ErrorMessage;
exports.InitializeMessage = InitializeMessage;

var _class = require('common/utils/class');

// cannot use const - doesn't work in IE. Use var instead.
var CHANGE = exports.CHANGE = 'change';
var RESPONSE = exports.RESPONSE = 'response';
var ERROR = exports.ERROR = 'error';

var LOAD = exports.LOAD = 'load';
var INSERT = exports.INSERT = 'insert';
var UPDATE = exports.UPDATE = 'update';
var REMOVE = exports.REMOVE = 'remove';

var INITIALIZE = exports.INITIALIZE = 'initialize';

function BaseMessage(type) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Object.assign(this, _extends({
        type: type
    }, props));
}

BaseMessage.create = _class.create;
BaseMessage.extend = _class.extend;

function ChangeMessage(target) {
    var changes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    BaseMessage.call(this, CHANGE, {
        target: target,
        changes: changes
    });
}

// make instanceof work
BaseMessage.extend(ChangeMessage);

function ResponseMessage(response, requestMessage) {
    BaseMessage.call(this, RESPONSE, {
        data: response,
        requestMessage: requestMessage
    });
}

BaseMessage.extend(ResponseMessage);

function RequestMessage(type, apiEndpointAlias, props) {
    BaseMessage.call(this, type, _extends({
        apiEndpointAlias: apiEndpointAlias
    }, props));
}

BaseMessage.extend(RequestMessage, {
    resolve: function resolve() {},
    reject: function reject() {}
});

function ErrorMessage(error, target) {
    BaseMessage.call(this, ERROR, {
        error: error,
        target: target
    });
}

BaseMessage.extend(ErrorMessage);

function InitializeMessage() {
    BaseMessage.call(this, INITIALIZE);
}

BaseMessage.extend(InitializeMessage);


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/messages/index.js
 ** module id = 503
 ** module chunks = 0 1
 **/